const ContactAddress = (props: any) => {
    const textAlign = props.textAlign ? props.textAlign : "center";
    return (
        <>
            <p className="inter-thin" style={{"textAlign": textAlign, "margin": "0"}}>
                Ж.Г Южен Парк, бул. “арсеналски 125, 1421 София, българия, Пощенска кутия №456
            </p>
        </>
    )
}

export default ContactAddress;